<div>
  <div class="row">
    <div class="col-sm-12">
      <h2>{{ 'revenue.credit-card-transactions.title' | translate | titlecase }}</h2>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-3">
      {{ 'common.start-date' | translate | titlecase }}
    </div>
    <div class="col-sm-3">
      {{ 'common.end-date' | translate | titlecase }}
    </div>
    <div class="col-sm-6"></div>
  </div>
  <div class="row">
    <div class="col-sm-2">
      <wl-date-selector name="startDate" [(ngModel)]="searchParams.StartDate"></wl-date-selector>
    </div>
    <div class="col-sm-2">
      <wl-date-selector name="endDate" [(ngModel)]="searchParams.EndDate"></wl-date-selector>
    </div>
    <div class="col-sm-4">
      <select class="form-control" [(ngModel)]="selectedGatewayId" (ngModelChange)="onGatewayChange($event)">
        <option *ngFor="let gateway of creditCardGateways" [value]="gateway.CCGatewayID">
          {{ gateway.Name }}
        </option>
      </select>
    </div>
    <div class="col-sm-2">
      <span class="input-group-btn">
        <button
          pButton
          type="button"
          class="btn btn-primary"
          icon="pi pi-search"
          [label]="'common.search' | translate"
          (click)="executeSearch($event)"
        ></button>
        <wl-busy [show]="searching"></wl-busy>
      </span>
    </div>
    <!--<div class="col-sm-2">
            <button pButton type="button" class="btn btn-primary" (click)="processCreditCard()">{{'integrations.card-connect.card-connect-trans.process-card-with-no-system-transaction'|translate|titlecase}}</button>
        </div>-->
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div *ngIf="searchHasResults">
        <div>
          <p-table [showGridlines]="true"
            scrollHeight="100%"
            scrollWidth="100%"
            [value]="searchResult.Result"
            [rows]="25"
            [paginator]="true"
            [pageLinks]="3"
            [lazy]="true"
            [totalRecords]="searchResult.TotalCount"
            (onLazyLoad)="executeSearch($event)"
          >
            <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
              <SortAltIcon *ngIf="sortOrder === 0">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
              <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
              <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th [pSortableColumn]="'Id'">
                  {{ 'common.id' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'DateDue'" class="text-center">
                  {{'common.revenue.tran-date'|translate|titlecase}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'InvoiceLineItemDescription'">
                  {{ 'common.description' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Amount'" class="text-right">
                  {{ 'common.revenue.amount' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'NameOnCard'">
                  {{ 'revenue.credit-card-transactions.name-on-card' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'TransactionId'">
                  {{ 'revenue.credit-card-transactions.processor-tran-id' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'AuthorizationCode'">
                  {{ 'revenue.credit-card-transactions.processor-auth-code' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'InvoiceNum'">
                  {{ 'common.revenue.invoice-number' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td>
                  <a (click)="selectTransaction(item.Id)">{{ item.Id }}</a>
                </td>
                <td class="text-center">{{ item.TranDate | date: 'shortDate' }}</td>
                <td>{{ item.InvoiceLineItemDescription }}</td>
                <td class="text-right">{{ item.Amount | currency }}</td>
                <td>{{ item.NameOnCard }}</td>
                <td>{{ item.TransactionId }}</td>
                <td>{{ item.AuthorizationCode }}</td>
                <td>{{ item.InvoiceNum }}</td>
                <td>
                  <button pButton type="button" class="btn btn-primary" (click)="getTransactionDetail(item)">
                    {{ 'common.detail' | translate | titlecase }}
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-progressSpinner *ngIf="searching"></p-progressSpinner>
        </div>
      </div>
      <div *ngIf="!searchHasResults && searchPerformed">
        <h4>{{ 'common.phrases.no-results-found' | translate }}</h4>
      </div>
    </div>
  </div>

  <p-dialog
    #transDetail
    [(visible)]="showModal"
    modal="true"
    [closable]="true"
    styleClass="atlas-dialog-l"
    [focusOnShow]="false"
    [contentStyle]="{ 'max-height': '75vh' }"
  >
    <ng-template pTemplate="header">
      <h4 class="modal-title">
        {{ 'revenue.credit-card-transactions.trans-detail-title' | translate | titlecase }}
      </h4>
    </ng-template>

    <div style="height: 375px">
      <div class="row">
        <div class="col-sm-3">
          {{ 'common.id' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.Id }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'common.personal-information.profile-id' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.ProfileId }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'revenue.credit-card-transactions.processor-tran-id' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.TransactionId }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'revenue.credit-card-transactions.processor-auth-code' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.AuthorizationCode }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'common.revenue.amount' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.Amount | currency }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'revenue.credit-card-transactions.due-date' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.DueDate | date: 'shortDate' }}
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'revenue.credit-card-transactions.payment-date' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          {{ selectedTransaction.PaymentDate | date: 'shortDate' }}
        </div>
        <div class="col-sm-6"></div>
      </div>
      <hr />
      <div class="row">
        <div class="col-sm-3"></div>
        <div class="col-sm-3">
          <button pButton type="button" class="btn btn-primary" (click)="getLineItems(selectedTransaction.Id)">
            {{ 'revenue.credit-card-transactions.line-items' | translate | titlecase }}
          </button>
          <wl-busy [show]="isFetchingLineItems"></wl-busy>
        </div>
        <div class="col-sm-6"></div>
      </div>
      <div class="row" [hidden]="!showLineItems">
        <div class="col-sm-6">
          <p-table [showGridlines]="true"
            scrollHeight="100%"
            scrollWidth="100%"
            [value]="creditCardPaymentLineItems"
            [paginator]="false"
            [totalRecords]="creditCardPaymentLineItems.length"
          >
            <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
              <SortAltIcon *ngIf="sortOrder === 0">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
              <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
              <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th [pSortableColumn]="'Descr'">
                  {{ 'common.description' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Amount'">
                  {{ 'common.revenue.amount' | translate | titlecase }}
                  <p-sortIcon></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr>
                <td>{{ item.Descr }}</td>
                <td>{{ item.Amount | currency }}</td>
              </tr>
            </ng-template>
          </p-table>
          <p-progressSpinner *ngIf="searching"></p-progressSpinner>
        </div>
        <div class="col-sm-6"></div>
      </div>
      <hr />
      <div class="row">
        <div class="col-sm-3">
          <b>{{ 'common.issue' | translate | titlecase }} {{ 'common.revenue.refund' | translate | titlecase }}</b>
        </div>
        <div class="col-sm-3"></div>
        <div class="col-sm-6"></div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          {{ 'common.revenue.adjustment-type' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          <select class="form-control" [(ngModel)]="selectedAdjustmentTypeId" (ngModelChange)="onAdjustmentTypeChange($event)">
            <option *ngFor="let adjustmentType of adjustmentTypes" [value]="adjustmentType.AdjustmentTypeId">
              {{ adjustmentType.AdjustmentType }}
            </option>
          </select>
        </div>
        <div class="col-sm-6"></div>
      </div>

      <div class="row">
        <div class="col-sm-3">
          {{ 'common.revenue.refund' | translate | titlecase }} {{ 'common.revenue.amount' | translate | titlecase }}
        </div>
        <div class="col-sm-3">
          <input
            type="number"
            class="form-control text-right"
            [(ngModel)]="refundRequest.RefundAmount"
            (ngModelChange)="onRefundAmountChange($event)"
          />
        </div>
        <div class="col-sm-6"></div>
      </div>
      <div class="row">
        <div class="col-sm-3">{{ 'common.revenue.refund' | translate | titlecase }} {{ 'common.description' | translate | titlecase }}</div>
        <div class="col-sm-3">
          <textarea type="number" class="form-control" [(ngModel)]="refundRequest.RefundReason"></textarea>
        </div>
        <div class="col-sm-6"></div>
      </div>
      <div class="row">
        <div class="col-sm-3"></div>
        <div class="col-sm-3">
          <button pButton type="button" class="btn btn-primary" (click)="refundCreditCardTransaction()" [disabled]="!refundIsValid()">
            {{ 'common.revenue.refund' | translate | titlecase }} {{ 'common.revenue.credit-card' | translate | titlecase }}
            {{ 'common.revenue.transaction' | translate | titlecase }}
          </button>
        </div>
        <div class="col-sm-6">
          <div>{{ this.refundResponse.RawTransactionResult }}</div>
        </div>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div>
        <button pButton type="button" class="btn btn-default" (click)="this.showModal = false">Close</button>
      </div>
    </ng-template>
  </p-dialog>
</div>
